// Admin console entry (admin/index.html → this). Built separately from the
// runner app (vite.admin.config.ts) so none of this ships to runners.

import "../styles/tokens.css";
import "../styles/onboarding.css";
import "../styles/paceapp.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AdminApp } from "./AdminApp";

const root = document.getElementById("root");
if (!root) throw new Error("admin: #root missing");
createRoot(root).render(
  <StrictMode>
    <AdminApp />
  </StrictMode>,
);
